import { render, staticRenderFns } from "./BuyPackets.vue?vue&type=template&id=53957966&lang=pug&"
import script from "./BuyPackets.vue?vue&type=script&lang=ts&"
export * from "./BuyPackets.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports